<template>
  <div class="phone-login">
    <h1>Connect with your phone</h1>
    <h2>You will receive a PIN number via SMS.</h2>

    <div class="input-container">
      <div class="phone-container">
        <pk-input v-model="ddi" placeholder="+1" type="text" :maxlength="3" />
        <pk-input v-model="ddd" type="text" :maxlength="2" />
        <pk-input v-model="phone" type="text" :maxlength="10" />
      </div>
      <error-text :active="!!error" :text="error" />
      <btn flat :loading="loading" @click="sendPin" submit>Send Pin</btn>
    </div>
  </div>
</template>

<script>
export default {
  name: 'phone-login',
  data: () => ({
    loading: false,
    error: null,
    ddi: '',
    ddd: '',
    phone: ''
  }),
  methods: {
    async sendPin() {
      this.error = null
      this.loading = true

      try {
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.phone-login {
  .input-container {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    max-width: min-content;

    @media screen and (max-width: 718px) {
      max-width: unset;
      width: 100%;
    }

    .phone-container {
      display: flex;
      width: 100%;

      .pk-input {
        font-size: 1.6rem;
        margin-right: 12px;
        flex-grow: 0;
        text-align: center;

        &:nth-child(1) {
          width: 7rem;
        }

        &:nth-child(2) {
          width: 5.4rem;
        }

        &:nth-child(3) {
          margin-right: 0;
          width: 14rem;
        }
      }
    }
  }
}
</style>
